import { render } from "./CoupleSettings.vue?vue&type=template&id=6faa0740&scoped=true"
import script from "./CoupleSettings.vue?vue&type=script&lang=js"
export * from "./CoupleSettings.vue?vue&type=script&lang=js"

import "./CoupleSettings.vue?vue&type=style&index=0&id=6faa0740&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faa0740"]])

export default __exports__